import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import {
  ZCatalogRecord,
  ZCatalogRecordToSave,
} from "src/business/records/ZCatalogRecord";
import { onError } from "src/common/onError";
import { LoaderBox } from "src/components/LoaderBox";
import { MForm } from "src/components/MForm";
import { MfErrorsListView } from "src/components/MForm/components/MfErrorsListView";
import { MFormStore } from "src/components/MForm/MFormStore";
import { PageBlocker } from "src/components/PageBlocker";
import { PageSubheader } from "src/components/PageSubheader";
import { ToolBox2 } from "src/components/ToolBox2";

import { CDSFormStore } from "./CDSFormStore";
import { makeRecordDataToSave } from "./makeRecordDataToSave";

type PropsCatalogRecordForm = {
  title: React.ReactNode;
  okText: string;
  store: CDSFormStore;
  submit(values: ZCatalogRecordToSave): Promise<ZCatalogRecord>;
  onSuccess(newData: ZCatalogRecord): void;
  extra?: React.ReactNode;
  readOnly?: boolean;
};

export const CatalogRecordForm: React.FC<PropsCatalogRecordForm> = observer(
  (props) => {
    const {
      store: { form: formStore },
      store,
      title,
      okText,
      submit,
      onSuccess,
      extra,
      readOnly,
    } = props;

    const cvtAndSubmit = React.useCallback(
      async (values: unknown): Promise<ZCatalogRecord> => {
        const svData: ZCatalogRecordToSave = makeRecordDataToSave(
          JSON.parse(JSON.stringify(values)),
          store.schemes,
        );
        return submit(svData);
      },
      [store.schemes],
    );

    const onFinish = async () => {
      const res: Error | ZCatalogRecord =
        await formStore.onFinish(cvtAndSubmit);
      if (!(res instanceof Error)) {
        onSuccess(res);
        // Раньше было:
        //   store.setPrevValues(res.data);
        // Но от этого вылез баг MDM2-749
        // Потому что Классификация - это системные данные и они отсутствует в res.data
        await store.reload();
      }
    };

    return (
      <LoaderBox
        remoteData={store.data}
        drawReady={() => (
          <Inner
            onFinish={onFinish}
            store={store}
            title={title}
            extra={extra}
            formStore={formStore}
            okText={okText}
            readOnly={readOnly}
          />
        )}
      />
    );
  },
);

type PropsInner = {
  title: React.ReactNode;
  store: CDSFormStore;
  onFinish: () => Promise<void>;
  extra?: React.ReactNode;
  formStore: MFormStore;
  okText: string;
  readOnly?: boolean;
};

const Inner: React.FC<PropsInner> = observer(
  ({ onFinish, store, title, extra, formStore, okText, readOnly }) => (
    <>
      <PageBlocker changed={() => store.isChanged} />
      <ToolBox2
        mainTool={
          <PageSubheader title={title}>
            {store.isChanged && <span>*</span>}
            {extra}
            {!readOnly && (
              <Button
                type="primary"
                loading={formStore.saving}
                onClick={() => onFinish().catch(onError)}
              >
                {okText}
              </Button>
            )}
          </PageSubheader>
        }
        footer={<MfErrorsListView store={store.errorsStore} />}
      >
        <MForm store={formStore} />
      </ToolBox2>
    </>
  ),
);
